export default __webpack_public_path__ + "assets/ThemingArticleHeaderPic.jpg";